import OrderService from '../../services/OrderService'

const state = () => ({
    orderLoading: false,
    orders: []
})
  
const mutations = {
    SET_ORDERS: (state, payload) => {
        state.orders = payload
    },
    SET_CREATED_ORDER: (state, payload) => {
        state.orders = [payload]
    },
    SET_ORDER_LOADING: (state, payload) => {
        state.orderLoading = payload
    }
}

const actions = {
    async fetchMyOrders({ commit }, id){
        try {
            commit('SET_ORDER_LOADING', true);
            const response = await OrderService.get();
            commit('SET_ORDERS', response.data)
            commit('SET_ORDER_LOADING', false);
        } catch (error) {
            commit('REDIRECT', '/track_order');
            commit('SET_ORDER_LOADING', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createOrder({commit, dispatch, rootState}, {dataOrder, dataPayment}){
        try {
            commit('SET_ORDER_LOADING', true);
            dataOrder.shippingSelect = rootState.shipping.shippingSelect;
            const response = await OrderService.post(dataOrder);
            commit('SET_CREATED_ORDER', response.data)
            if(dataPayment.PaymentMethod == 'pix'){
                dataPayment.data.OrderId = response.data.order.id;
                await dispatch('createPaymentPix', dataPayment.data)
            } else if(dataPayment.PaymentMethod == 'card'){
                dataPayment.data.OrderId = response.data.order.id;
                await dispatch('createPaymentCard', dataPayment.data)
            }
            commit('SET_ORDER_LOADING', false);
        } catch (error) {
            commit('REDIRECT', '/checkout');
            commit('SET_ORDER_LOADING', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async confirmarPagamento({ commit }, OrderId) {
        try {
            commit('SET_ORDER_LOADING', true);
            await OrderService.confirm(OrderId);
            commit('SET_ORDER_LOADING', false);
        } catch (error) {
            console.log('Falha ao dar baixa no pedido:', error.response.data.message)
        }
    }
}

const getters = {
    getOrderLoading: state => state.orderLoading,
    getOrders: state => state.orders

}

export default {
    state,
    getters,
    mutations,
    actions
};